import NcImage from "components/NcImage/NcImage";
import Pagination from "components/Pagination/Pagination";
import React, { FC } from "react";

export interface PageAboutProps {
  holder?:Array<any>;
  cnt?:number;
}


const DashboardPosts:FC<PageAboutProps> = ({ holder = [] })  => {
  return (
    <div className="mt-4 flex flex-col space-y-8">
      <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="py-2 align-middle inline-block min-w-full px-1 sm:px-6 lg:px-8">
          <div className="shadow dark:border dark:border-neutral-800 overflow-hidden sm:rounded-lg">
            <table className="min-w-full divide-y divide-neutral-200 dark:divide-neutral-800">
              <thead className="bg-neutral-50 dark:bg-neutral-800">
                <tr className="text-left text-xs font-medium text-neutral-500 dark:text-neutral-300 uppercase tracking-wider">
                  <th scope="col" className="px-6 py-3">
                    No.
                  </th>
                  <th scope="col" className="px-9 py-3">
                    Address
                  </th>
                  <th scope="col" className="px-3 py-3">
                    Staked
                  </th>
                  <th scope="col" className="px-3 py-3">
                    Nickname
                  </th>

                </tr>
              </thead>
              <tbody className="bg-white dark:bg-neutral-900 divide-y divide-neutral-200 dark:divide-neutral-800">
                {holder.map((item) => (
                  <tr key={item.id}>

                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="px-2 inline-flex text-sm text-neutral-500 dark:text-neutral-400 rounded-full">
                      {item.id}
                      </span>
                    </td>

                    <td className="px-3 py-4">
                      <div className="flex w-30 lg:w-auto overflow-hidden">

                        {/* holder address */}
                        <div className="ml-4 flex-grow">
                          <h2 className="inline-flex line-clamp-2 text-sm font-semibold  dark:text-neutral-300">
                            {`${item.address?.substring(0,4)}...${item.address?.substring(item.address.length-4,item.address.length)}, ${(item.rate*100).toFixed(2)}%`}
                          </h2>
                        </div>
                      </div>
                    </td>
                    <td className="px-2 py-4 whitespace-nowrap">
                      <span className="px-2 inline-flex text-xs leading-5 font-medium rounded-full bg-teal-100 text-teal-900 lg:text-sm">
                      {item.staked}
                      </span>
                    </td>

                    <td className="px-2 py-4 whitespace-nowrap">
                      <span className="px-2 inline-flex text-xs leading-5 font-medium rounded-full bg-red-100 text-teal-900 lg:text-sm">
                      {item.nickname}
                      </span>
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>
  );
};

export default DashboardPosts;
